import { useState } from "react";
import axios from "axios";
import { Reveal } from "@/components/Reveal";
import { ScrambleText } from "@/components/ScrambleText";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const FIELD_CLASS =
  "w-full border border-white/15 bg-transparent px-5 py-4 text-sm text-[#E4E5EA] outline-none transition-colors placeholder:text-[#6B7280] focus:border-[#C4A24C]";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [state, setState] = useState("idle");

  const set = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setState("sending");
    try {
      await axios.post(`${API}/contact-messages`, form);
      setState("done");
    } catch {
      setState("error");
    }
  };

  return (
    <section id="contact" data-testid="contact-section" className="px-6 py-32 text-center lg:py-44">
      <Reveal>
        <p className="text-xs uppercase tracking-[0.35em] text-[#C4A24C]"><ScrambleText text="06 / Contact" /></p>
        <h2 className="mt-8 font-serif text-4xl text-[#C4A24C] sm:text-5xl">Contact Us</h2>
        <p className="mt-8 text-sm text-[#E4E5EA]/90 sm:text-base">
          NDA executed prior to full disclosure.
        </p>

        {state === "done" ? (
          <p
            data-testid="contact-success-message"
            className="mx-auto mt-14 max-w-md border border-[#C4A24C]/50 px-8 py-6 font-serif text-lg text-[#C4A24C]"
          >
            Message received. We'll be in touch shortly.
          </p>
        ) : (
          <form
            data-testid="contact-form"
            onSubmit={submit}
            className="mx-auto mt-14 flex max-w-lg flex-col gap-4 text-left"
          >
            <input
              type="text"
              required
              value={form.name}
              onChange={set("name")}
              data-testid="contact-name-input"
              placeholder="Name"
              className={FIELD_CLASS}
            />
            <input
              type="email"
              required
              value={form.email}
              onChange={set("email")}
              data-testid="contact-email-input"
              placeholder="Email address"
              className={FIELD_CLASS}
            />
            <textarea
              required
              rows={4}
              value={form.message}
              onChange={set("message")}
              data-testid="contact-message-input"
              placeholder="Message"
              className={`${FIELD_CLASS} resize-none`}
            />
            <button
              type="submit"
              disabled={state === "sending"}
              data-testid="contact-submit-button"
              className="mt-2 bg-[#C4A24C] px-8 py-4 text-sm font-semibold uppercase tracking-[0.25em] text-[#09090F] transition-colors duration-300 hover:bg-[#E8D08A] disabled:opacity-60"
            >
              {state === "sending" ? "Sending…" : "Send Message"}
            </button>
          </form>
        )}
        {state === "error" && (
          <p data-testid="contact-error-message" className="mt-4 text-sm text-[#E05D4A]">
            Submission failed. Please try again.
          </p>
        )}
      </Reveal>
    </section>
  );
}
